import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant/index.jsx';
import { _axios } from '../../utils/axios';
import Swal from 'sweetalert2';
import UpdatePurple from '../../assets/images/svg/UpdatePurple.svg';
import UpdateBlue from '../../assets/images/svg/UpdateBlue.svg';
import CalendarEdit from '../../assets/images/svg/calendar_edit.svg';

const EditQA = (props) => {
    const [show, setShow] = useState(false);
    const [qaId, setQAId] = useState(props?.data?.qa_id);
    const [question, setQuestion] = useState('');
    const [author, setAuthor] = useState('');
    const [dateTime, setDateTime] = useState('');
    const [reports, setReports] = useState('0');
    const [status, setStatus] = useState('');
    const [updating, setUpdating] = useState(false);
    const [showRejectionModal, setShowRejectionModal] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [showReportPopup, setShowReportPopup] = useState(false);
    const [reportData, setReportData] = useState({
        totalReports: 0,
        reportReasons: [],
        uniqueReporters: 0
    });

    const fetchReportData = async (qaId) => {
        if (qaId) {
            try {
                const response = await _axios.get(`${ServerPath}/community-qa/reports/count/${qaId}`);
                if (response.data.success === 1) {
                    const { total_reports, report_reasons, unique_reporters } = response.data.data;

                    // Define the complete phrases we want to keep together
                    const completeReasons = [
                        "I just don't like it",
                        "Nudity or sexual activity",
                        "Scam, fraud or spam",
                        "Suicide, self-injury or eating disorders",
                        "Bullying or unwanted contact",
                        "Violence, hate or exploitation",
                        "Selling or promoting restricted items",
                        "False information"
                    ];

                    // Filter and match complete phrases from the report_reasons string
                    const reasonsArray = completeReasons.filter(phrase =>
                        report_reasons?.toLowerCase().includes(phrase.toLowerCase())
                    );

                    setReportData({
                        totalReports: total_reports,
                        reportReasons: reasonsArray,
                        uniqueReporters: unique_reporters
                    });
                }
            } catch (error) {
                console.error('Error in fetchReportData:', error);
                setReportData({
                    totalReports: 0,
                    reportReasons: [],
                    uniqueReporters: 0
                });
            }
        }
    };

    useEffect(() => {
        fetchReportData(props.data?.qa_id);
    }, [props.data?.qa_id]);

    useEffect(() => {
        if (props.data) {
            setQAId(props.data.qa_id);
            setQuestion(props.data.qa_details || '');
            setAuthor(props.data.user_name || '');
            setDateTime(formatDate(props.data.created_on));
            setStatus(props.data.status || 'Pending');
        }
    }, [props.data]);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!status) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Status is required',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        setUpdating(true);
        try {
            const updatedQA = {
                status: status,
                qa_id: qaId,
                reason: rejectionReason,
                modified_by: props.data.user_name,
                user_id : props.data.user_id
            };

            const response = await _axios.post(`${ServerPath}/qaAdmin/update-status`, updatedQA);

            if (response.data.success === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Q&A updated successfully',
                    confirmButtonColor: '#3085d6',
                }).then(() => {
                    handleClose();
                    if (props.onUpdate) {
                        props.onUpdate();
                    } else {
                        window.location.reload();
                    }
                });
            }
        } catch (error) {
            console.error('Error updating Q&A:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'An error occurred while updating the Q&A',
                confirmButtonColor: '#3085d6',
            });
        } finally {
            setUpdating(false);
        }
    };

    const handleRejection = async () => {
        if (!rejectionReason.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Rejection reason is required',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        try {
            const updatedQA = {
                status: 'Cancelled',
                rejection_reason: rejectionReason,
                qa_id: qaId,
                modified_by: props.data.user_name,
                user_id : props.data.user_id
            };

            const response = await _axios.post(`${ServerPath}/qaAdmin/update-status`, updatedQA);

            if (response.data.success === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Q&A rejected successfully',
                    confirmButtonColor: '#3085d6',
                }).then(() => {
                    setShowRejectionModal(false);
                    handleClose();
                    if (props.onUpdate) {
                        props.onUpdate();
                    } else {
                        window.location.reload();
                    }
                });
            }
        } catch (error) {
            console.error('Error rejecting Q&A:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'An error occurred while rejecting the Q&A',
                confirmButtonColor: '#3085d6',
            });
        }
    };

    return (
        <>
            <button
                className="btn-icon-only bg-transparent border-0 p-0"
                onClick={handleShow}
                onMouseEnter={(e) => {
                    e.currentTarget.querySelector('img').src = UpdateBlue;
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.querySelector('img').src = UpdatePurple;
                }}
            >
                <img
                    src={UpdatePurple}
                    alt="Update"
                    style={{ width: '24px', height: '24px' }}
                />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton className="bg-white border-bottom" style={{ paddingLeft: '24px' }}>
                    <Modal.Title style={{ color: '#000' }}>Update Report</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4">
                    <Form id='EditQAForm' onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6} className="mb-4">
                                <Form.Group controlId="formGridQuestion">
                                    <Form.Label>Question</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={question}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridAuthor">
                                    <Form.Label>Author</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={author}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridDateTime">
                                    <Form.Label>Date & Time</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            value={dateTime}
                                            readOnly
                                            disabled
                                            className="bg-light"
                                        />
                                        <img
                                            src={CalendarEdit}
                                            alt="calendar"
                                            style={{
                                                position: 'absolute',
                                                right: '12px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '20px',
                                                height: '20px',
                                                pointerEvents: 'none'
                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridReports">
                                    <Form.Label style={{
                                        color: '#FF4D4F',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        marginBottom: '8px'
                                    }}>
                                        Reports
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={`${reportData.totalReports} Reports`}
                                        readOnly
                                        onClick={() => setShowReportPopup(true)}
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: '#fff',
                                            border: '1px solid #dee2e6',
                                            borderRadius: '8px',
                                            padding: '8px 12px',
                                            fontSize: '16px',
                                            color: '#333',
                                            boxShadow: 'none',
                                            height: 'auto'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridStatus">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                        required
                                        style={{ color: 'black' }}
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Pending Moderation">Pending Moderation</option>
                                        <option value="Review">Review</option>
                                        <option value="Reported">Reported</option>
                                        <option value="Cancelled">Cancelled</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top">
                    <Button
                        variant="#F24822"
                        onClick={() => {
                            handleClose();
                            setShowRejectionModal(true);
                        }}
                        style={{
                            backgroundColor: '#F24822',
                            border: 'none',
                            padding: '8px 24px',
                            color: 'white'
                        }}
                    >
                        Reject
                    </Button>
                    <Button
                        form='EditQAForm'
                        variant="#EEB830"
                        type='submit'
                        disabled={updating}
                        style={{
                            backgroundColor: '#EEB830',
                            border: 'none',
                            padding: '8px 24px',
                            color: 'white'
                        }}
                    >
                        {updating ? 'Updating...' : 'Update'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Report Popup Modal */}
            <Modal
                show={showReportPopup}
                onHide={() => setShowReportPopup(false)}
                centered
                size="md"
                style={{
                    borderRadius: '16px',
                    overflow: 'hidden'
                }}
            >
                <Modal.Body className="p-4">
                    {/* Header Section */}
                    <div className="d-flex align-items-center mb-4">
                        {/* Alert Circle with ! */}
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#FFE5E5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '12px'
                        }}>
                            <span style={{ color: '#FF4D4F', fontWeight: 'bold' }}>!</span>
                        </div>

                        {/* Title and Reports Count */}
                        <div className="d-flex align-items-center">
                            <span style={{
                                color: '#FF4D4F',
                                marginRight: '12px',
                                fontSize: '16px',
                                fontWeight: '500'
                            }}>
                                Q&A Reported
                            </span>
                            <span style={{
                                backgroundColor: '#FFE5E5',
                                borderRadius: '20px',
                                padding: '4px 12px',
                                color: '#FF4D4F',
                                fontSize: '14px'
                            }}>
                                {reportData.totalReports} Reports
                            </span>
                        </div>
                    </div>

                    {/* Content Section */}
                    <p style={{
                        fontSize: '14px',
                        marginBottom: '16px'
                    }}>
                        Multiple users reported content violations
                    </p>

                    {/* Reasons Box */}
                    <div style={{
                        backgroundColor: '#FFE5E5',
                        padding: '16px',
                        borderRadius: '8px',
                        marginBottom: '24px'
                    }}>
                        {reportData.reportReasons.map((reason, index) => (
                            <div key={index} className="d-flex align-items-center" style={{
                                marginBottom: index !== reportData.reportReasons.length - 1 ? '12px' : '0'
                            }}>
                                <span style={{
                                    color: '#FF4D4F',
                                    marginRight: '8px',
                                    fontSize: '20px'
                                }}>•</span>
                                <span style={{
                                    color: '#FF4D4F',
                                    fontSize: '14px'
                                }}>{reason}</span>
                            </div>
                        ))}
                    </div>

                    {/* Cancel Button */}
                    <div className="text-end">
                        <Button
                            variant="light"
                            onClick={() => setShowReportPopup(false)}
                            style={{
                                backgroundColor: '#DEE2E6',
                                border: 'none',
                                color: 'black',
                                padding: '6px 16px',
                                fontSize: '14px',
                                borderRadius: '6px'
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Rejection Modal */}
            <Modal
                show={showRejectionModal}
                onHide={() => setShowRejectionModal(false)}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Header closeButton className="bg-white border-bottom">
                    <Modal.Title>Rejection Q&A</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Rejection Reason <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            placeholder="Enter rejection reason"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="warning"
                        onClick={() => {
                            setShowRejectionModal(false);
                            setTimeout(() => {
                                setShow(true);
                            }, 100);
                        }}
                        style={{
                            backgroundColor: '#EEB830',
                            border: 'none',
                            padding: '8px 24px',
                            color: 'white'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleRejection}
                        style={{
                            backgroundColor: '#F24822',
                            border: 'none',
                            padding: '8px 24px',
                            color: 'white'
                        }}
                    >
                        Reject
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditQA;